module.exports = __webpack_public_path__ + "img/cszq_partners_7.b3ec358e.jpg";